import { AICompletionQuoteApiModel } from '../../../api/ai/model/AI-completion-quote-api.model';

export class AiQuoteModel {
    text: string;
    name: string;
    organization: string;
    title: string;

    constructor(text?: string, name?: string, organization?: string, title?: string) {
        this.text = text;
        this.name = name;
        this.organization = organization;
        this.title = title;
    }

    getApiModel(): AICompletionQuoteApiModel {
        if (!this.text?.trim() && !this.name?.trim() && !this.title?.trim() && !this.organization?.trim()) {
            return null;
        }

        return {
            quote: this.text,
            name: this.name,
            role: this.title,
            organization: this.organization
        };
    }
}
